/*
Natural sort helpers
Usage (faster perf.):
    1. chunkify your entire array `var tobesorted = arr.map(function(v){ return natural_sort_chunkify(v); });`
    2. sort chunkified array `tobesorted.sort(natural_sort_compare_chunks);`

Usage (slower perf.):
    1. define your compare function similar to natural_sort_compare() function
    2. sort your array `arr.sort(natural_sort_compare);`
*/
function natural_sort_chunkify(t)
{
    var x = 0, y = -1, n = 0, i, j, m, tz = new Array();
    while (i = (j = t.charAt(x++)).charCodeAt(0)) {
        m = (i >=48 && i <= 57);
        if (m !== n) {
            tz[++y] = "";
            n = m;
        }
        tz[y] += j;
    }
    return tz;
}

function natural_sort_compare_chunks(aa, bb)
{
    var c, d;
    for (var i = 0; aa[i] && bb[i]; i++) {
        if (aa[i] !== bb[i]) {
            c = Number(aa[i]);
            d = Number(bb[i]);
            if (c == aa[i] && d == bb[i]) {
                return c - d;
            } else {
                return aa[i].localeCompare(bb[i]);
            }
        }
    }
    return aa.length - bb.length;
}

function natural_sort_compare(a, b)
{
    return natural_sort_compare_chunks(
        natural_sort_chunkify(a),
        natural_sort_chunkify(b)
    );
}
